import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from "@/environments/environment";
import * as LZString from "lz-string";

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private secretKey = environment?.ENCRYPTION_SECRET_KEY || "DEVELOPER001"; 

  // 🔐 compress + encrypt
  encrypt(data: any): string {
    const json_str = JSON.stringify(data);

    // 1. Compress
    const compressed = LZString.compressToUTF16(json_str);

    // 2. Encrypt compressed
    return CryptoJS.AES.encrypt(compressed, this.secretKey).toString();
  }

  // 🔓 decrypt + decompress
  decrypt(data: string): any {
    try {
      // 1. Decrypt AES
      const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) return null;

      // 2. Decompress
      const decompressed = LZString.decompressFromUTF16(decrypted);
      return JSON.parse(decompressed!);
    } catch (e) {
      console.error("Decryption failed", e);
      return null;
    }
  }
}
